import { cloneDeep } from 'lodash'

// Used as a workaround for https://github.com/rjsf-team/react-jsonschema-form/pull/3714
// TODO: remove this once the issue is fixed
export function cleanEmptyProperties<T extends { [key: string]: any }>(input: T): T {
  const o = cloneDeep(input)

  for (var k in o) {
    if (typeof o[k] === 'undefined' || o[k] === '') {
      delete o[k]
    }

    if (!o[k] || typeof o[k] !== 'object') {
      continue
    }

    o[k] = cleanEmptyProperties(o[k])
    if (!Object.keys(o[k]).length) {
      delete o[k]
    }
  }

  return o
}
